// extracted by mini-css-extract-plugin
module.exports = {"underlineOnHover":"style-module__underlineOnHover___2L5Em"};